import { addDays, eachDayOfInterval, isSameDay } from 'date-fns';

import { type Zeitraum } from '../dtos';

export function addDaysToZeitraum(zeitraum: Zeitraum, days: number): Zeitraum {
  return {
    start: addDays(zeitraum.start, days),
    end: addDays(zeitraum.end, days),
  };
}

export function isDateInZeitraum(zeitraum: Zeitraum, date: Date): boolean {
  return eachDayOfInterval(zeitraum).some((zeitraumDay) => isSameDay(zeitraumDay, date));
}

export function isDateInZeitraeume(zeitraeume: readonly Zeitraum[], date: Date): boolean {
  return zeitraeume.some((zeitraum) => isDateInZeitraum(zeitraum, date));
}

export function getZeitraeumeStartEnd(zeitraeume: readonly Zeitraum[]): Zeitraum {
  if (zeitraeume.length === 0) {
    throw new Error('Zeitraeume muss mindestens einen Tag enthalten');
  }

  let start = zeitraeume[0].start;
  let end = zeitraeume[0].end;
  for (const zeitraum of zeitraeume) {
    if (zeitraum.start < start) {
      start = zeitraum.start;
    }

    if (zeitraum.end > end) {
      end = zeitraum.end;
    }
  }

  return { start, end };
}
